import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ToastController, Toast } from 'ionic-angular';
import 'rxjs';

import 'rxjs/add/operator/map';

import { ProductPrototyp } from '../../assets/shared/products.object';
import { RcsConnectorOdooProvider } from '../rcs-connector-odoo/rcs-connector-odoo';
import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';
import { FullTextSearch } from '../rcs-connector-index-db/fulltextsearch';

@Injectable()
export class SyncProductsProvider{

    private toast: Toast
    private prozess = [0.0];

  constructor(
    private odoo_service: RcsConnectorOdooProvider,
    private db_service: RcsConnectorIndexDbProvider,
    private toast_controller: ToastController,
  ){}

    // Create Toast
  private create_toast(message, duration):void{
    this.toast = this.toast_controller.create({
      message: message,
      position: 'down',
      duration: duration
    })
    this.toast.present();
  }

  public sync_products(complete: boolean){
    localStorage.setItem('sync', 'active');
    this.prozess = [0,0];
    // let finish_flag = new BehaviorSubject(false);
    this.db_service.get_record_by_key('login', 'user_login').subscribe(
      login => {
        if (login !== undefined){
          this.get_last_sync_date().subscribe(sync_date => {
            let filter = [["is_customer_service", "=", true]];
            if (sync_date !== null && !complete){
              filter.push(['product_tmpl_id.write_date', '>', sync_date]);
            }

            this.odoo_service.count_records(login, 'product.product', filter, {"active_test": false}).subscribe(
              result => {
                const amount = result.json().result;
                if (amount > 0){
                  let offset = 0;
                  this.prozess[1] = amount;
                  this.create_toast(this.prozess[0] + ' von ' + this.prozess[1] + ' Produkten geladen', 0);
                  this.get_products(amount, login, filter, offset);
                  let sync_date = this.create_ISO_Date();
                  this.db_service.update_record('system', sync_date, 'product_sync_data');
                }else{
                  this.create_toast('Alle Produkte sind aktuell', 3000)
                  localStorage.removeItem('sync');
                }
              }
            )
          })
        }
      }
    )
  }

  private get_last_sync_date(){
    return this.db_service.get_record_by_key('system', 'product_sync_data')
      .map(date => {
        if (typeof date === 'undefined'){
          let sync_date = this.create_ISO_Date();
          this.db_service.add_record('system', sync_date, 'product_sync_data');
          return null;
        }else{
          return date;
        }
      })
  }

  private create_ISO_Date(){
    Date.prototype.localISOString = function() {
      var tzo = -this.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function(num) {
      var norm = Math.floor(Math.abs(num));
      return (norm < 10 ? '0' : '') + norm;
    };
    return this.getFullYear() +
      '-' + pad(this.getMonth() + 1) +
      '-' + pad(this.getDate()) +
      'T' + pad(this.getHours()-2) +
      ':' + pad(this.getMinutes()) +
      ':' + pad(this.getSeconds()) +
      dif + pad(tzo / 60) +
      ':' + pad(tzo % 60);
    }
    let sync_date = new Date();
    let date_string = sync_date.localISOString().replace('T', ' ');
    var n = date_string.indexOf('+');
    return date_string.substring(0, n != -1 ? n : date_string.length);
  }

  private get_products(total_amount, login, filter, offset){
    let fields = new ProductPrototyp().get_attributs();
    let network_state = localStorage.getItem('online_status');

    this.odoo_service.get_products(login, 'product.product', filter, fields, offset, 1000, {"active_test": false, "lang": "de_DE"})
      .map( products => { return products.json().result })
      .subscribe(
        products => { this.save_products(products) },
        error => {},
        () => {
          offset += 1000;
          if (offset <= total_amount){
            network_state = localStorage.getItem('online_status');
            if (network_state === 'true'){
              this.get_products(total_amount, login, filter, offset);
            }
          }
      }
    )
  }

  private save_products(products){
    for (let product of products){
      this.db_service.get_record_by_key('products', product.id).subscribe(
        result => {
          if (typeof result !== 'undefined'){
            if (!product.active){
              this.db_service.delete_record('products', product.id).subscribe(
                success => { 
                  this.prozess[0] ++;
                  this.hide_toast();
                },
                error => { this.create_toast(error, 3000) }
              );
            }else{
              product = this.convert_product(product);
              this.db_service.update_record('products', product, product.id).subscribe(
                success => { 
                  this.prozess[0] ++;
                  this.hide_toast();
                },
                error => { this.create_toast(error, 3000) }
              );
            }
          }else{
            product = this.convert_product(product);
            this.db_service.add('products', product, product.id).subscribe(
              success => { 
                this.prozess[0] ++;
                this.hide_toast();
              },
              error => { this.create_toast(error, 3000) }
            );
          }
        }
      )
    }
  }

  private hide_toast(){
    this.toast.setMessage(this.prozess[0] + ' von ' + this.prozess[1] + ' Produkten geladen');
    if (this.prozess[0] == this.prozess[1]){
      localStorage.removeItem('sync');
      this.toast.dismiss();
    }
  }

  private convert_product(product){
    if( Object.prototype.toString.call(product.seller_id) === '[object Array]' ) {
      product.seller_number = JSON.stringify(product.seller_id[0]);
      product.seller_name = product.seller_id[1];
      if (!product.description){
        product.description = '';
      }
      product.fulltext_search = new FullTextSearch().tokenize(
        product.name + ',' +
        product.seller_name + ',' +
        product.supplier_product_code + ',' +
        product.supplier_code_search + ',' +
        product.description + ',' +
        product.default_code_tmpl, 'en');
      //product.name_search = new FullTextSearch().tokenize(product.name, 'en');
      //product.article_number_search = product.default_code_tmpl;
      //product.seller_name_search = new FullTextSearch().tokenize(product.seller_name, 'en');
      delete(product.seller_id);
    }
    return product
  }
}



// WEBPACK FOOTER //
// ./src/providers/rcs-sync-data-service/sync-products.service.ts